import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { style: {"min-height":"450px"} }
const _hoisted_2 = ["value"]
const _hoisted_3 = {
  key: 1,
  class: "list-group"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_6 = {
  key: 2,
  class: "text-center"
}
const _hoisted_7 = { style: {"margin-top":"15px"} }
const _hoisted_8 = ["value"]

import { computed } from 'vue'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PanelistVoteEditor',
  props: {
    comment: {},
    value: {},
    scaleLevels: {}
  },
  emits: ["update-value", "update-comment"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- computed ----------------

    const hasScale = computed(() =>
        props.scaleLevels != null && props.scaleLevels.length > 0
    )

    // ---------------- actions ----------------

    function updateValue(val: number | null)
    {
        emit('update-value', val)
    }

    function updateComment(comment: string | null)
    {
        emit('update-comment', comment)
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!hasScale.value)
      ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          type: "number",
          value: __props.value,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (updateValue(parseFloat($event.target.value)))),
          class: "form-control"
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2))
      : _createCommentVNode("v-if", true),
    (hasScale.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.scaleLevels, (sl) => {
            return (_openBlock(), _createElementBlock("a", {
              class: _normalizeClass(["list-group-item list-group-item-action text-center", {'bg-success': __props.value === sl.Value, 'bg-white': __props.value !== sl.Value}]),
              onClick: ($event: any) => (updateValue(sl.Value))
            }, [
              _createElementVNode("strong", null, _toDisplayString(sl.Value) + " - " + _toDisplayString(sl.Name), 1 /* TEXT */),
              (sl.Definition)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(sl.Definition), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], 10 /* CLASS, PROPS */, _hoisted_4))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    (__props.value != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-link mt1",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (updateValue(null)))
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("i", {
              class: "fa fa-times",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Clear answer ", -1 /* CACHED */)
          ]))])
        ]))
      : _createCommentVNode("v-if", true),
    _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("textarea", {
        rows: "5",
        value: __props.comment,
        onInput: _cache[2] || (_cache[2] = ($event: any) => (updateComment($event.target.value))),
        class: "form-control",
        placeholder: "Comment..."
      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_8)
    ])
  ]))
}
}

})